// @ts-nocheck
import { useEffect, useRef, useState, useMemo } from "react";
// REMOVE: import { loadModules } from "esri-loader";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

// OPENLAYERS IMPORTS (Replace ArcGIS imports)
import Map from "ol/Map"; // ArcGIS Map → ol/Map
import View from "ol/View"; // ArcGIS MapView → ol/View
import TileLayer from "ol/layer/Tile"; // ArcGIS WebTileLayer → ol/layer/Tile
import VectorLayer from "ol/layer/Vector"; // ArcGIS FeatureLayer → ol/layer/Vector
import VectorSource from "ol/source/Vector"; // ArcGIS FeatureLayer source → ol/source/Vector
import XYZ from "ol/source/XYZ"; // ArcGIS WebTileLayer → ol/source/XYZ
import { fromLonLat, transformExtent } from "ol/proj"; // Convert coordinates
import { Style, Icon, Fill, Stroke, Text, Circle } from "ol/style"; // ArcGIS symbols → ol/style
import Feature from "ol/Feature"; // ArcGIS Graphic → ol/Feature
import Point from "ol/geom/Point"; // ArcGIS Point → ol/geom/Point
import GeoJSON from "ol/format/GeoJSON"; // For loading feature data
import { Draw } from "ol/interaction"; // ArcGIS Measurement → ol/interaction/Draw
import { getArea, getLength } from "ol/sphere"; // For measurement calculations
import { defaults as defaultControls } from "ol/control";
import { TileWMS } from "ol/source"; // For WMS layer

// Your existing imports (keep these)
import {
  gisFeatureLayerFilter,
  gisSites,
  landDetailsToggle,
  landParcelId,
  landSummary,
  landSummaryToggle,
  siteFilterState,
  updateGisFilter,
} from "../../state/atom/gis";
import { mapCenter } from "../../state/atom/generic";
import { Form, Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Http } from "../../utility/http";
import { JwtPayLoad } from "../../shared/jwt.interface";
import { getUserDetails } from "../../utility/jwt";
import { ROLES, ROLESNAME } from "../../shared/role.constant";
import { requestList } from "../../state/atom/request";
import { apiHeaders } from "../../utility/generic";
import axios from "axios";
import { Button, OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { Overlay } from "ol";

export interface Props {
  classList?: string;
  mapHeight?: string;
  showExtraButton: boolean;
}

export const GISMapOL = ({ classList, mapHeight, showExtraButton }: Props) => {
  // STEP 1: KEEP ALL YOUR EXISTING STATE (NO CHANGES)
  const [landSummaryData, setLandSummary] = useRecoilState(landSummary);
  const setLandSummaryToggle = useSetRecoilState(landSummaryToggle);
  const landRequest = useRecoilValue(requestList);
  const updateGisFilterTrigger = useRecoilValue(updateGisFilter);
  const sites = useRecoilValue(gisSites);
  const [transparency, setTransparency] = useState(false);
  const [toggleLabel, setToggleLabel] = useState(true);
  const setLandDetailsToggle = useSetRecoilState(landDetailsToggle);
  const setLandParcelId = useSetRecoilState(landParcelId);
  const mapCenterPostion = useRecoilValue(mapCenter);
  const [siteFilter, setSiteFilter] = useRecoilState(siteFilterState);
  const mapRef = useRef(null);
  let [gisFeatureLayerFilterData, setGisFeatureLayerFilter] = useRecoilState(gisFeatureLayerFilter);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingPdf, setPdfLoading] = useState(false);

  
  const measurementWidgetRef = useRef(null);

  // ArcGIS: view → OpenLayers: viewRef
  const [view, setView] = useState(null); // Keep as state if needed

  // ArcGIS: filterRef (FeatureLayer) → OpenLayers: landParcelLayerRef
  const landParcelsLayerRef = useRef(null); // Will store VectorLayer for land parcels

  // ArcGIS: projectRef (FeatureLayer) → OpenLayers: projectBoundaryLayerRef
  const projectRef = useRef(null); // Will store VectorLayer for project boundary

  // ArcGIS: highlightRef (GraphicsLayer) → OpenLayers: highlightLayerRef
  const highlightRef = useRef(null); // Will store VectorLayer for highlighting

  const markersLayerRef = useRef(null);

  const { user }: JwtPayLoad = getUserDetails();
  const [pageOption, setPageOption] = useState({ size: "", type: "" });

  // Additional OpenLayers refs we need
  const mapInstance = useRef(null); // The OpenLayers Map object
  const vectorSource = useRef(new VectorSource()); // For measurement drawings
  const [basemaps, setBasemaps] = useState<{ Street: TileLayer; Satellite: TileLayer } | null>(
    null,
  );
  const [activeBasemap, setActiveBasemap] = useState<"Street" | "Satellite">("Satellite");
  const [measurementActive, setMeasurementActive] = useState(null);
  const tooltipRef = useRef(null);
  const tooltipOverlayRef = useRef(null);
  const [measurementUnit, setMeasurementUnit] = useState({
    distance: "meters",
    area: "squareMeters",
  });
  const GEOSERVER_URL = process.env.REACT_APP_GEOSERVER_URL;

  // ================================================
  // STEP 3: REPLACE createMap FUNCTION
  // ================================================
  const createMap = useMemo(
    () => async () => {
      console.log("Creating OpenLayers map...");
      const indiaExtent = [68.111378, 6.554607, 97.395561, 35.674545];
      const indiaExtentTransformed = transformExtent(indiaExtent, "EPSG:4326", "EPSG:3857");
      try {
        // ================================================
        // STEP 3A: CREATE BASEMAP (replaces ArcGIS basemap: "satellite")
        // ================================================
        const streetsBasemap = new TileLayer({
          source: new XYZ({
            url: "https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
            // attributions: "© Google Maps",
          }),
          visible: false,
        });

        const satelliteBasemap = new TileLayer({
          source: new XYZ({
            url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
            // attributions: "© Google Maps",
            crossOrigin: "anonymous",
            tileSize: 256,
          }),
          visible: true,
        });
        // Store layers for switching
        setBasemaps({
          Street: streetsBasemap,
          Satellite: satelliteBasemap,
        });
        const basemaps = {
          satellite: satelliteBasemap,
          streets: streetsBasemap,
        };

        // ================================================
        // STEP 3B: CREATE VIEW (replaces ArcGIS MapView)
        // ================================================
        const view = new View({
          center: fromLonLat(mapCenterPostion.center || [71.5724, 22.6708]),
          zoom: 5,
          maxZoom: 20,
          minZoom: 2,
          extent: indiaExtentTransformed,
          constrainOnlyCenter: true,
        });
        setView(view); // Store view if needed elsewhere

        // ================================================
        // STEP 3C: CREATE HIGHLIGHT LAYER (replaces ArcGIS GraphicsLayer)
        // ================================================
        const highlightSource = new VectorSource();
        const highlightLayer = new VectorLayer({
          source: highlightSource,
          style: new Style({
            fill: new Fill({
              color: "rgba(255, 255, 0, 0.4)", // Yellow highlight
            }),
            stroke: new Stroke({
              color: "rgba(255, 255, 0, 1)",
              width: 3,
            }),
          }),
          zIndex: 1000, // Make sure it's on top
        });
        highlightRef.current = highlightLayer;

        // ================================================
        // 🔥 4. CREATE LAND PARCELS LAYER (WFS - VECTOR LAYER)
        // ================================================
        // Create empty vector source - will be populated when site is selected
        const landParcelsSource = new VectorSource({
          format: new GeoJSON(),
        });
        const landParcelsLayer = new VectorLayer({
          source: landParcelsSource,
          style: (feature) => {
            console.log("Feature", feature);
            // Dynamic styling based on parcel status
            // const status = feature.get("Status") || feature.get("status");
            let fillColor = "#9c9c9cff";
            let strokeColor = "#ffffffff";
            // console.log('Status', status);
            // // Color coding based on status
            // switch (status?.toLowerCase()) {
            //   case "approved":
            //     fillColor = "rgba(0, 255, 0, 0.3)"; // Green
            //     strokeColor = "#00AA00";
            //     break;
            //   case "pending":
            //     fillColor = "rgba(255, 255, 0, 0.3)"; // Yellow
            //     strokeColor = "#FFAA00";
            //     break;
            //   case "rejected":
            //     fillColor = "rgba(255, 0, 0, 0.3)"; // Red
            //     strokeColor = "#FF0000";
            //     break;
            //   case "in progress":
            //     fillColor = "rgba(0, 150, 255, 0.3)"; // Blue
            //     strokeColor = "#0096FF";
            //     break;
            // }

            return new Style({
              fill: new Fill({ color: fillColor }),
              stroke: new Stroke({
                color: strokeColor,
                width: 1.5,
              }),
              text: toggleLabel
                ? new Text({
                    text: feature.get("SurveyNo") || feature.get("survey_no") || "",
                    font: "bold 11px Adani, sans-serif",
                    fill: new Fill({ color: "#000" }),
                    stroke: new Stroke({ color: "#fff", width: 3 }),
                    offsetY: -15,
                  })
                : undefined,
            });
          },
          visible: false, // Initially hidden until site is selected
        });
        landParcelsLayerRef.current = landParcelsLayer;

        // ================================================
        // STEP 3D: CREATE MARKERS LAYER (replaces ArcGIS GraphicsLayer for points)
        // ================================================
        const markersSource = new VectorSource();
        const markersLayer = new VectorLayer({
          source: markersSource,
          // Style will be set per feature based on status
        });
        markersLayerRef.current = markersLayer;

        // ================================================
        // STEP 3E: ADD MARKERS FROM landRequest
        // ================================================
        landRequest.data.landRequest.forEach((marker) => {
          let iconUrl = "images/pending-marker.png";

          if (marker.requestStatus === "pending") {
            iconUrl = "images/pending-marker.png";
          }
          if (marker.requestStatus === "in_progress") {
            iconUrl = "images/in-progress-marker.png";
          }
          if (marker.requestStatus === "acquisition") {
            iconUrl = "images/acquisition-marker.png";
          }
          if (marker.requestStatus === "proposal_assigned") {
            iconUrl = "images/proposal-assigned-marker.png";
          }

          // Create point feature (replaces ArcGIS Graphic)
          const point = new Point(fromLonLat([marker.locationLon, marker.locationLat]));

          const markerFeature = new Feature({
            geometry: point,
            attributes: {
              type: "picture",
              status: marker.requestStatus,
            },
          });

          // Set icon style (replaces ArcGIS PictureMarkerSymbol)
          markerFeature.setStyle(
            new Style({
              image: new Icon({
                src: iconUrl,
                scale: 0.8,
                anchor: [0.5, 1],
              }),
            }),
          );

          markersSource.addFeature(markerFeature);

          // Create text label (replaces ArcGIS TextSymbol)
          const textFeature = new Feature({
            geometry: point,
            attributes: {
              type: "text",
              text: marker.location,
            },
          });

          // Initially hidden (visible: false in ArcGIS)
          textFeature.setStyle(
            new Style({
              text: new Text({
                text: "", // Empty initially
                font: "12px Calibri,sans-serif",
                fill: new Fill({ color: "#fff" }),
                offsetY: -20,
              }),
            }),
          );

          markersSource.addFeature(textFeature);
        });

        // ================================================
        // STEP 3F: ZOOM-BASED LABEL VISIBILITY (replaces view.watch("zoom"))
        // ================================================
        view.on("change:resolution", () => {
          const zoomLevel = view.getZoom();
          markersSource.getFeatures().forEach((feature) => {
            const attrs = feature.get("attributes");
            if (attrs && attrs.type === "text") {
              const newStyle = new Style({
                text: new Text({
                  text: zoomLevel > 8 ? attrs.text : "", // Show at zoom > 8
                  font: "12px Calibri,sans-serif",
                  fill: new Fill({ color: "#fff" }),
                  offsetY: -20,
                }),
              });
              feature.setStyle(newStyle);
            }
          });
        });

        // ================================================
        // STEP 3G: CREATE LAND PARCEL LAYER (replaces ArcGIS FeatureLayer)
        // ================================================
        // const landParcelsLayer = new TileLayer({
        //   source: new TileWMS({
        //     url: "http://141.148.200.50:8080/geoserver/lgeom_lams/wms",
        //     params: {
        //       LAYERS: "lgeom_lams:land_parcels",
        //       TILED: true,
        //       VERSION: "1.1.0",
        //       FORMAT: "image/png",
        //       TRANSPARENT: true,
        //     },
        //     serverType: "geoserver",
        //   }),
        //   visible: false, // Initially hidden
        //   opacity: 1,
        // });
        // filterRef.current = landParcelsLayer;

        // ================================================
        // STEP 3H: CREATE BOUNDARY LAYERS (replaces ArcGIS FeatureLayers)
        // ================================================
        // District Boundary
        /*  const districtSource = new VectorSource({
          url: process.env.REACT_APP_DISTRICT_BOUNDARY?.replace("FeatureServer", "geojson"),
          format: new GeoJSON(),
        });

        const districtLayer = new VectorLayer({
          source: districtSource,
          style: new Style({
            stroke: new Stroke({
              color: "rgba(0, 0, 255, 0.5)",
              width: 1,
            }),
            fill: new Fill({
              color: "rgba(0, 0, 255, 0.1)",
            }),
          }),
        }); */

        // State Boundary
        /*  const stateSource = new VectorSource({
          url: process.env.REACT_APP_STATE_BOUNDARY?.replace("FeatureServer", "geojson"),
          format: new GeoJSON(),
        });

        const stateLayer = new VectorLayer({
          source: stateSource,
          style: new Style({
            stroke: new Stroke({
              color: "rgba(255, 0, 0, 0.5)",
              width: 2,
            }),
            fill: new Fill({
              color: "rgba(255, 0, 0, 0.1)",
            }),
          }),
        }); */

        // Village Boundary
        /*  const villageSource = new VectorSource({
          url: process.env.REACT_APP_VILLAGE_BOUNDARY?.replace("FeatureServer", "geojson"),
          format: new GeoJSON(),
        });

        const villageLayer = new VectorLayer({
          source: villageSource,
          style: new Style({
            stroke: new Stroke({
              color: "rgba(0, 255, 0, 0.5)",
              width: 0.5,
            }),
            fill: new Fill({
              color: "rgba(0, 255, 0, 0.1)",
            }),
          }),
        }); */

        // Project Boundary (replaces projectBoundray FeatureLayer)
        /* const projectBoundarySource = new VectorSource({
          url: process.env.REACT_APP_PROJECT_BOUNDARY?.replace("FeatureServer", "geojson"),
          format: new GeoJSON(),
        });

        const projectBoundaryLayer = new VectorLayer({
          source: projectBoundarySource,
          style: new Style({
            stroke: new Stroke({
              color: "rgba(255, 0, 0, 1)",
              width: 3,
            }),
            fill: new Fill({
              color: "rgba(255, 0, 0, 0.1)",
            }),
          }),
          // Initially hidden (replaces definitionExpression: "SITENAME='not-exist'")
          visible: false,
        });
        projectRef.current = projectBoundaryLayer; */

        // ================================================
        // STEP 3I: CREATE THE MAP (replaces ArcGIS Map)
        // ================================================
        const map = new Map({
          target: mapRef.current,
          layers: [
            satelliteBasemap,
            streetsBasemap,
            // stateLayer,
            // districtLayer,
            // villageLayer,
            landParcelsLayer,
            // projectBoundaryLayer,
            markersLayer,
            highlightLayer,
          ],
          view: view,
          controls: defaultControls({
            attribution: false,
            zoom: true,
            rotate: false,
          }),
        });

        // ================================================
        // CREATE MEASUREMENT TOOLTIP OVERLAY
        // ================================================
        const tooltipElement = document.createElement("div");
        tooltipElement.className = "measurement-tooltip";
        tooltipElement.style.cssText = `
        position: absolute;
        background: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 8px 12px;
        border-radius: 4px;
        font-size: 14px;
        font-family: Adani;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.2s;
        z-index: 10000;
        white-space: nowrap;
        `;
        tooltipRef.current = tooltipElement;

        const tooltipOverlay = new Overlay({
          element: tooltipElement,
          offset: [15, 0],
          positioning: "center-left",
        });
        tooltipOverlayRef.current = tooltipOverlay;
        map.addOverlay(tooltipOverlay);

        mapInstance.current = map;

        // ================================================
        // STEP 3J: ADD CLICK INTERACTION (replaces view.on("click"))
        // ================================================
        map.on("singleclick", async (event) => {
          console.log("Map clicked at:", event.coordinate);
          // Clear previous highlight
          if (highlightSource) {
            highlightSource.clear();
          }

          // Check if land parcels layer is visible
          const landParcelsLayer = landParcelsLayerRef.current;
          if (!landParcelsLayer || !landParcelsLayer.getVisible()) {
            console.log("Land parcels layer is not visible");
            return;
          }

          // Check for clicked features
          map.forEachFeatureAtPixel(event.pixel, (feature) => {
            const layer = feature.get("layer") || "";

            // Check if it's a land parcel feature
            if (layer.includes("land_parcels") || feature.get("id") || feature.get("SurveyNo")) {
              const properties = feature.getProperties();

              console.log("Clicked feature properties:", properties);

              const parcelId = properties.id;

              if (parcelId) {
                // Highlight the feature
                const highlightFeature = new Feature({
                  geometry: feature.getGeometry(),
                });
                highlightSource.addFeature(highlightFeature);

                // 🔥 TOGGLE STATES
                setLandSummaryToggle(false);
                setLandParcelId(parcelId);
                setLandDetailsToggle(true);
                // setLandDetailsData(properties);

                // Zoom to feature (optional)
                const extent = feature.getGeometry().getExtent();
                if (extent && extent[0] !== Infinity) {
                  view.fit(extent, {
                    padding: [30, 30, 30, 30],
                    duration: 500,
                    maxZoom: 17,
                  });
                }

                return true; // Stop checking other features
              }
            }
          });

          // try {
          //   // FOR WMS LAYERS: USE GetFeatureInfo REQUEST
          //   const viewResolution = view.getResolution();
          //   const source = landParcelsLayer.getSource();

          //   // Generate GetFeatureInfo URL
          //   const url = source.getFeatureInfoUrl(event.coordinate, viewResolution, "EPSG:3857", {
          //     INFO_FORMAT: "application/json", // Get JSON response
          //     FEATURE_COUNT: 10, // Get multiple features if overlapping
          //   });

          //   console.log("GetFeatureInfo URL:", url);

          //   if (url) {
          //     // Fetch feature information
          //     const response = await fetch(url);
          //     const featureData = await response.json();

          //     console.log("Feature data received:", featureData);

          //     if (featureData.features && featureData.features.length > 0) {
          //       // Get the first feature (you could let user choose if multiple)
          //       const feature = featureData.features[0];
          //       const properties = feature.properties;

          //       console.log("Clicked feature properties:", properties);

          //       // Check if it's a land parcel feature
          //       if (properties.id) {
          //         const parcelId = properties.id;
          //         console.log("parcelId", parcelId);
          //         // FIX: CHECK IF FEATURE HAS GEOMETRY BEFORE CREATING HIGHLIGHT
          //         if (feature.geometry && feature.geometry.coordinates) {
          //           const geoJSONFormat = new GeoJSON();
          //           const olFeature = geoJSONFormat.readFeature(feature, {
          //             featureProjection: map.getView().getProjection(),
          //           });

          //           const geometry = olFeature.getGeometry();
          //           if (geometry && geometry.getType() !== undefined) {
          //             if (highlightSource) {
          //               const highlightFeature = new Feature({
          //                 geometry: geometry,
          //               });
          //               highlightSource.addFeature(highlightFeature);
          //               // FIX: CHECK EXTENT BEFORE ZOOMING
          //               // console.log('geometry',geometry);
          //               // const extend = geometry.getExtent();
          //               // if (extent && extent[0] !== Infinity && extent[2] !== Infinity) {
          //               //   // Check if extent is valid (not empty)
          //               //   const isValidExtent = extent.every(
          //               //     (coord) => !isNaN(coord) && Math.abs(coord) !== Infinity,
          //               //   );
          //               //   if (isValidExtent) {
          //               //     view.fit(extent, {
          //               //       padding: [20, 20, 20, 20],
          //               //       duration: 500,
          //               //       maxZoom: 18,
          //               //     });
          //               //     console.log("✅ Zoomed to feature extent");
          //               //   } else {
          //               //     console.warn("Invalid extent coordinates:", extent);
          //               //   }
          //               // } else {
          //               //   console.warn("Empty or invalid extent:", extent);
          //               // }
          //             }
          //           } else {
          //             console.warn("Feature has no valid geometry");
          //           }
          //         } else {
          //           console.warn("Feature missing geometry data:", feature);
          //         }

          //         // 🔥 TOGGLE THE STATES
          //         if (parcelId) {
          //           setLandSummaryToggle(false);
          //           setLandParcelId(parcelId);
          //           setLandDetailsToggle(true);

          //           console.log(`✅ States toggled:
          //     - setLandSummaryToggle(false)
          //     - setLandParcelId(${parcelId})
          //     - setLandDetailsToggle(true)
          //   `);
          //         } else {
          //           console.log("No ID found in feature properties");
          //         }
          //       } else {
          //         console.log("No features found at clicked location");
          //       }
          //     }
          //   }
          // } catch (error) {
          //   console.error("Error getting feature info:", error);
          // }

          // map.forEachFeatureAtPixel(event.pixel, (feature) => {
          //   const attributes = feature.getProperties();

          //   // This will work for vector layers (markers, highlights, etc.)
          //   console.log("Vector feature clicked:", attributes);
          //   return true; // Stop checking other features
          // });
        });

        setIsLoading(false);
        console.log("✓ OpenLayers map created successfully!");
      } catch (error) {
        console.error("Error creating OpenLayers map:", error);
        setIsLoading(false);
      }
    },
    [
      mapCenterPostion.center,
      setLandDetailsToggle,
      setLandParcelId,
      setLandSummaryToggle,
      landRequest,
      toggleLabel,
      // toggleLabel, // Added dependency for label toggling
    ],
  );

  // ================================================
  // STEP 4: KEEP SAME useEffect TO CREATE MAP
  // ================================================
  useEffect(() => {
    createMap();

    // Cleanup function
    return () => {
      if (mapInstance.current) {
        mapInstance.current.setTarget(null);
        mapInstance.current = null;
      }
    };
  }, [createMap]);

  // // ================================================
  // // SITE FILTER ZOOM FUNCTION
  // // ================================================
  // const zoomToSiteExtent = (siteId) => {
  //   if (!mapInstance.current || !view) return;

  //   console.log("Zooming to site:", siteId);

  //   // For demonstration, using a hardcoded bbox from your URL
  //   // In production, you would fetch this from your API based on siteId
  //   const bbox = [72.22227478027344, 21.676231384277344, 72.22366333007812, 21.677635192871094];

  //   // Convert bbox from EPSG:4326 to EPSG:3857 (OpenLayers default)
  //   const transformedExtent = transformExtent(bbox, "EPSG:4326", "EPSG:3857");

  //   // Zoom to extent
  //   view.fit(transformedExtent, {
  //     padding: [50, 50, 50, 50],
  //     duration: 1000,
  //     maxZoom: 18,
  //   });

  //   // Show the land parcels layer
  //   if (filterRef.current) {
  //     filterRef.current.setVisible(true);
  //     filterRef.current.setOpacity(1);
  //   }
  // };

  const loadLandParcelsForSite = async (siteName) => {
    if (!landParcelsLayerRef.current || !mapInstance.current) {
      console.error("Map or layer not initialized");
      return;
    }

    try {
      console.log(`Loading land parcels for site: ${siteName}`);

      const landParcelsLayer = landParcelsLayerRef.current;
      const source = landParcelsLayer.getSource();

      // Clear existing features
      source.clear();

      if (!siteName) {
        console.log("No site selected, hiding layer");
        landParcelsLayer.setVisible(false);
        return;
      }

      // Build WFS URL with CQL filter
      const wfsUrl = new URL(GEOSERVER_URL);
      wfsUrl.searchParams.append("service", "WFS");
      wfsUrl.searchParams.append("version", "2.0.0");
      wfsUrl.searchParams.append("request", "GetFeature");
      wfsUrl.searchParams.append("typeNames", "lgeom_lams:land_parcels");
      wfsUrl.searchParams.append("outputFormat", "application/json");

      // 🔥 ADD CQL FILTER FOR SITE
      if (siteName) {
        wfsUrl.searchParams.append("CQL_FILTER", `site='${siteName}'`);
      }

      // Optional: Limit number of features for performance
      wfsUrl.searchParams.append("maxFeatures", "1000");

      const fullUrl = wfsUrl.toString();
      console.log("WFS Request URL:", fullUrl);

      // Show loading state
      landParcelsLayer.setVisible(true);

      // 🔥 FIX: USE fetch TO LOAD FEATURES
      const response = await fetch(fullUrl);
      const geojsonData = await response.json();

      console.log(`Received ${geojsonData.features?.length || 0} features`);

      // Parse GeoJSON features
      const geoJSONFormat = new GeoJSON();
      const features = geoJSONFormat.readFeatures(geojsonData, {
        featureProjection: mapInstance.current.getView().getProjection(),
      });

      // Add features to source
      source.addFeatures(features);

      console.log(`✅ Loaded ${features.length} land parcels for site: ${siteName}`);

      // Zoom to extent of loaded features
      if (features.length > 0) {
        const extent = source.getExtent();
        if (extent && extent[0] !== Infinity) {
          if (markersLayerRef.current) {
            markersLayerRef.current.setVisible(false);
          }
          const view = mapInstance.current.getView();
          view.fit(extent, {
            padding: [50, 50, 50, 50],
            duration: 1000,
            maxZoom: 17,
            callback: () => {
              //  RESTORE MARKERS AFTER ZOOM
              if (markersLayerRef.current) {
                setTimeout(() => {
                  markersLayerRef.current.setVisible(true);
                }, 100);
              }
            },
          });
        }
      } else {
        console.warn(`No land parcels found for site: ${siteName}`);
      }
    } catch (error) {
      console.error("Error loading land parcels:", error);
      if (landParcelsLayerRef.current) {
        landParcelsLayerRef.current.setVisible(false);
      }
    }
  };

  // ================================================
  // 🔥 EFFECT TO LOAD PARCELS WHEN SITE FILTER CHANGES
  // ================================================
  useEffect(() => {
    if (siteFilter) {
      loadLandParcelsForSite(siteFilter);
    } else {
      // Clear parcels when no site is selected
      if (landParcelsLayerRef.current || highlightRef.current) {
        const source = landParcelsLayerRef.current.getSource();
        const hlSource = highlightRef.current.getSource();
        if (source || hlSource) {
          source.clear();
          hlSource.clear();
        }
        landParcelsLayerRef.current.setVisible(false);
        highlightRef.current.setVisible(false);

        // Zoom to default
        if (mapInstance.current && view) {
          view.animate({
            center: fromLonLat(mapCenterPostion.center || [71.5724, 22.6708]),
            zoom: 5,
            duration: 500,
          });
        }
      }
      setLandSummaryToggle(false);
      setLandDetailsToggle(false);
      setLandParcelId("");
    }
  }, [siteFilter, mapCenterPostion.center]);

  // ================================================
  // STEP 5: REPLACE MEASUREMENT FUNCTION
  // ================================================
  const toggleMeasurementType = (measureType) => {
    if (!mapInstance.current) return;

    // Remove existing measurement if any
    if (measurementWidgetRef.current) {
      mapInstance.current.removeInteraction(measurementWidgetRef.current);
      measurementWidgetRef.current = null;
    }

    // Clear previous drawings
    vectorSource.current.clear();

    // Hide tooltip
    if (tooltipRef.current) {
      tooltipRef.current.style.opacity = "0";
    }

    if (measureType) {
      // Create draw interaction
      const draw = new Draw({
        source: vectorSource.current,
        type: measureType === "distance" ? "LineString" : "Polygon",
        style: new Style({
          fill: new Fill({
            color: "rgba(255, 255, 255, 0.2)",
          }),
          stroke: new Stroke({
            color: measureType === "distance" ? "rgba(0, 100, 255, 0.8)" : "rgba(255, 100, 0, 0.8)",
            lineDash: [10, 10],
            width: 3,
          }),
          image: new Circle({
            radius: 5,
            stroke: new Stroke({
              color: measureType === "distance" ? "rgba(0, 100, 255, 1)" : "rgba(255, 100, 0, 1)",
              width: 2,
            }),
            fill: new Fill({
              color: "rgba(255, 255, 255, 0.8)",
            }),
          }),
        }),
      });

      // Add to map
      mapInstance.current.addInteraction(draw);
      measurementWidgetRef.current = draw;

      // Variables to track measurement
      let currentMeasurement = null;
      let lastCoordinate = null;

      // Update tooltip during drawing
      draw.on("drawstart", (event) => {
        currentMeasurement = event.feature;
        const geometry = currentMeasurement.getGeometry();

        geometry.on("change", (evt) => {
          if (!tooltipOverlayRef.current || !tooltipRef.current) return;

          const geom = evt.target;
          lastCoordinate = geom.getLastCoordinate();

          let result = "";
          let unit = "";

          if (measureType === "distance") {
            const length = getLength(geom);
            result = formatMeasurement(length, "distance");
            unit = "Length";
          } else {
            const area = getArea(geom);
            result = formatMeasurement(area, "area");
            unit = "Area";
          }

          // Update tooltip
          tooltipRef.current.innerHTML = `
          <div style="font-weight: bold; margin-bottom: 2px;">${unit}</div>
          <div>${result}</div>
        `;
          tooltipRef.current.style.opacity = "1";
          tooltipOverlayRef.current.setPosition(lastCoordinate);
        });
      });

      // Finalize measurement on draw end
      draw.on("drawend", (event) => {
        const geometry = event.feature.getGeometry();
        let result = "";
        let unit = "";

        if (measureType === "distance") {
          const length = getLength(geometry);
          result = formatDistance(length);
          unit = "Distance";
        } else {
          const area = getArea(geometry);
          result = formatArea(area);
          unit = "Area";
        }

        // Show final result
        if (tooltipRef.current && lastCoordinate) {
          tooltipRef.current.innerHTML = `
          <div style="font-weight: bold; margin-bottom: 2px;">${unit}</div>
          <div style="font-size: 16px; font-weight: bold;">${result}</div>
          <div style="font-size: 11px; margin-top: 4px; opacity: 0.8;">Click to start new measurement</div>
        `;
          tooltipOverlayRef.current.setPosition(lastCoordinate);

          // Auto-hide tooltip after 5 seconds
          setTimeout(() => {
            if (tooltipRef.current) {
              tooltipRef.current.style.opacity = "0";
            }
          }, 5000);
        }

        currentMeasurement = null;
      });

      // Clear measurement when clicking elsewhere
      mapInstance.current.on("click", (event) => {
        if (measurementWidgetRef.current && !measurementWidgetRef.current.getActive()) {
          vectorSource.current.clear();
          if (tooltipRef.current) {
            tooltipRef.current.style.opacity = "0";
          }
        }
      });
    }
  };

  // ================================================
  // HELPER FUNCTION TO FORMAT MEASUREMENTS
  // ================================================
  const formatMeasurement = (value, type) => {
    if (type === "distance") {
      switch (measurementUnit.distance) {
        case "meters":
          return `${value.toFixed(2)} m`;
        case "kilometers":
          return `${(value / 1000).toFixed(3)} km`;
        case "feet":
          return `${(value * 3.28084).toFixed(2)} ft`;
        case "miles":
          return `${(value * 0.000621371).toFixed(4)} mi`;
        default:
          return `${value.toFixed(2)} m`;
      }
    } else {
      switch (measurementUnit.area) {
        case "squareMeters":
          return `${value.toFixed(2)} m²`;
        case "squareKilometers":
          return `${(value / 1000000).toFixed(6)} km²`;
        case "squareFeet":
          return `${(value * 10.7639).toFixed(2)} ft²`;
        case "acres":
          return `${(value * 0.000247105).toFixed(4)} acres`;
        case "hectares":
          return `${(value / 10000).toFixed(4)} ha`;
        default:
          return `${value.toFixed(2)} m²`;
      }
    }
  };

  const formatDistance = (meters) => {
    if (meters >= 1000) {
      return `${(meters / 1000).toFixed(3)} km`;
    } else {
      return `${meters.toFixed(2)} m`;
    }
  };

  const formatArea = (squareMeters) => {
    if (squareMeters >= 10000) {
      return `${(squareMeters / 10000).toFixed(3)} hectares`;
    } else if (squareMeters >= 1000000) {
      return `${(squareMeters / 1000000).toFixed(4)} km²`;
    } else {
      return `${squareMeters.toFixed(2)} m²`;
    }
  };

  // ================================================
  // STEP 6: KEEP SAME useEffect FOR SITE FILTER CLEANUP
  // ================================================
  useEffect(() => {
    return () => {
      setSiteFilter("");
    };
  }, [setSiteFilter]);

  // ================================================
  // STEP 7: REPLACE FILTERING LOGIC
  // ================================================
  //   useEffect(() => {
  //     const applyFilters = async () => {
  //       if (!filterRef.current || !projectRef.current || !mapInstance.current) return;

  //       const hasFilters =
  //         Object.values(gisFeatureLayerFilterData).filter((item) => item !== "").length > 0;

  //       let definitionExpression = "";
  //       let projectBoundrayExpression = "";

  //       // Build filter expression (same logic as ArcGIS)
  //       if (user.role === ROLES.abu_spoc) {
  //         definitionExpression = `abu_or_lem_user_id='${user.userId}'`;
  //       }
  //       if (user.role === ROLES.le_spoc) {
  //         definitionExpression = `le_spoc_user_id='${user.userId}'`;
  //       }
  //       if (user.role === ROLES.le_dh) {
  //         definitionExpression = `le_dh_user_id='${user.userId}'`;
  //       }

  //       for (const filter of Object.keys(gisFeatureLayerFilterData)) {
  //         if (gisFeatureLayerFilterData[filter]) {
  //           if (definitionExpression) definitionExpression += " AND ";

  //           if (typeof gisFeatureLayerFilterData[filter] == "string") {
  //             definitionExpression += `${filter}='${gisFeatureLayerFilterData[filter]}'`;
  //           } else {
  //             definitionExpression += `${filter}=${gisFeatureLayerFilterData[filter]}`;
  //           }
  //         }
  //       }

  //       if (siteFilter) {
  //         if (definitionExpression) definitionExpression += " AND ";
  //         definitionExpression += `site='${siteFilter}'`;
  //         projectBoundrayExpression = `SITENAME='${siteFilter}'`;
  //       }

  //       console.log("Applying filter:", definitionExpression);

  //       const landParcelLayer = filterRef.current;
  //       const projectBoundaryLayer = projectRef.current;
  //       const view = mapInstance.current.getView();

  //       try {
  //         if (hasFilters || siteFilter) {
  //           if (definitionExpression) {
  //             // Update land parcel layer URL with filter
  //             const landSource = landParcelLayer.getSource();
  //             landSource.clear();
  //             landSource.setUrl(
  //               `${process.env.REACT_APP_ARC_GIS_URL?.replace(
  //                 "FeatureServer",
  //                 "geojson",
  //               )}?where=${encodeURIComponent(definitionExpression)}`,
  //             );
  //             landSource.refresh();
  //             landParcelLayer.setVisible(true);

  //             // Zoom to extent (replaces queryExtent + goTo)
  //             landSource.once("change", () => {
  //               const extent = landSource.getExtent();
  //               if (extent && extent[0] !== Infinity) {
  //                 view.fit(extent, {
  //                   padding: [50, 50, 50, 50],
  //                   duration: 500,
  //                 });
  //               }
  //             });

  //             // Update project boundary
  //             if (projectBoundrayExpression) {
  //               const projectSource = projectBoundaryLayer.getSource();
  //               projectSource.clear();
  //               projectSource.setUrl(
  //                 `${process.env.REACT_APP_PROJECT_BOUNDARY?.replace(
  //                   "FeatureServer",
  //                   "geojson",
  //                 )}?where=${encodeURIComponent(projectBoundrayExpression)}`,
  //               );
  //               projectSource.refresh();
  //               projectBoundaryLayer.setVisible(true);
  //             }
  //           }
  //         } else {
  //           // No filters - hide layers (replaces definitionExpression: "site='not-exist'")
  //           landParcelLayer.setVisible(false);
  //           projectBoundaryLayer.setVisible(false);

  //           // Zoom to default (replaces view.goTo)
  //           view.animate({
  //             center: fromLonLat(mapCenterPostion.center || [71.5724, 22.6708]),
  //             zoom: 5,
  //             duration: 500,
  //           });
  //         }
  //       } catch (e) {
  //         console.log("Error applying filters", e);
  //       }
  //     };

  //     applyFilters();
  //   }, [siteFilter, gisFeatureLayerFilterData, user.userId, user.role, updateGisFilterTrigger]);

  // ================================================
  // STEP 8: KEEP EXISTING EXPORT FUNCTIONS (NO CHANGES)
  // ================================================
  const exportKML = () => {
    setLoading(true);
    const site = siteFilter || gisFeatureLayerFilterData.Site;
    if (site) {
      Http.request("get", `${process.env.REACT_APP_EXPORT_KML_URL}&Site=${site}`, null)
        .then((result) => {
          setLoading(false);
          if (process.env.REACT_APP_API_URL.indexOf("developerteam.xyz") === -1) {
            const kmlUrl = result.results[0].value.url;
            window.location.href = kmlUrl;
          } else {
            const kmlUrl =
              "https://media-lams.developerteam.xyz/proposal/0d7c71d69421deda8b15542687569b46.kml";
            window.location.href = kmlUrl;
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }
  };

  const capitalizeFirstLetter = (str) => {
    if (str.length > 1) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    } else {
      return str.charAt(0).toUpperCase();
    }
  };

  const printPDF = () => {
    // Keep this function exactly as is
    const site = siteFilter || gisFeatureLayerFilterData.Site;

    setPdfLoading(true);
    if (site) {
      const userName = `${capitalizeFirstLetter(user?.firstName)} ${capitalizeFirstLetter(
        user?.lastName,
      )}`;

      Http.request(
        "get",
        `${process.env.REACT_APP_API_URL}land-parcel/site/details?site=${site}`,
        null,
        apiHeaders(),
      )
        .then((result1) => {
          Http.request(
            "get",
            `${process.env.REACT_APP_PRINT_URL}&site_name=${site}&business_unit=${result1?.data?.parcel?.business?.name}&user=${userName}&page_format=${pageOption.type}&orientation=${pageOption.size}`,
            null,
          )
            .then((result) => {
              if (process.env.REACT_APP_API_URL.indexOf("lgeom.com") === -1) {
                const kmlUrl = result.results[0].value.url;
                handleDownload(kmlUrl);
              } else {
                const kmlUrl =
                  "https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf";
                handleDownload(kmlUrl);
              }
            })
            .catch((error) => {
              setPdfLoading(false);
              console.log(error);
            });
        })
        .catch((error) => {});
    }
  };

  const handleDownload = async (path) => {
    try {
      const site = siteFilter || gisFeatureLayerFilterData.Site;
      const response = await axios.get(path, {
        responseType: "blob",
      });
      const blob = await response.data;
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${site}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
      setPdfLoading(false);
    } catch (error) {
      console.error("Error fetching PDF:", error);
      setPdfLoading(false);
    }
  };

  // ================================================
  // STEP 9: REPLACE LABEL TOGGLE FUNCTION
  // ================================================
  const setLabel = () => {
    const tglable = !toggleLabel;
    setToggleLabel(tglable);

    // Update land parcel layer style
    const landParcelLayer = filterRef.current;
    if (landParcelLayer) {
      landParcelLayer.setStyle((feature) => {
        return new Style({
          fill: new Fill({
            color: "rgba(255, 255, 255, 0.3)",
          }),
          stroke: new Stroke({
            color: "#3399CC",
            width: 1.25,
          }),
          text: tglable
            ? new Text({
                text: feature.get("SurveyNo") || "",
                font: "12px Calibri,sans-serif",
                fill: new Fill({ color: "#000" }),
                stroke: new Stroke({ color: "#fff", width: 3 }),
                offsetY: -15,
              })
            : undefined,
        });
      });
    }
  };

  // ================================================
  // STEP 10: REPLACE TRANSPARENCY SLIDER FUNCTION
  // ================================================
  const manageRangeSlider = (opacityValue) => {
    const landParcelLayer = filterRef.current;
    if (landParcelLayer) {
      landParcelLayer.setOpacity(opacityValue);
    }
  };

  // ================================================
  // STEP 11: KEEP SAME popoverForm (NO CHANGES)
  // ================================================
  const popoverForm = (
    <Popover id="popover-form">
      <Popover.Header as="h3">Print Options</Popover.Header>
      <Popover.Body>
        <div>
          <div className="mb-2">
            <label htmlFor="pageType" className="form-label">
              Page Type
            </label>
            <select
              className="form-control"
              id="pageType"
              onChange={(e) => {
                setPageOption((prev) => {
                  return {
                    ...prev,
                    type: e.target.value,
                  };
                });
              }}
            >
              <option value="A0">A0</option>
              <option value="A1">A1</option>
              <option value="A2">A2</option>
              <option value="A3">A3</option>
              <option value="A4">A4</option>
            </select>
          </div>

          <div className="mb-2">
            <label htmlFor="pageSize" className="form-label">
              Page Size
            </label>
            <select
              className="form-control"
              id="pageSize"
              onChange={(e) => {
                setPageOption((prev) => {
                  return {
                    ...prev,
                    size: e.target.value,
                  };
                });
              }}
            >
              <option value="Portrait">Portrait</option>
              <option value="landscape">Landscape</option>
            </select>
          </div>

          <Button variant="primary" onClick={printPDF}>
            {!loadingPdf && "Print"}
            {loadingPdf && (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            )}
          </Button>
        </div>
      </Popover.Body>
    </Popover>
  );

  // Base map switching function
  const changeBaseMap = (mapType) => {
    if (!basemaps) return;

    // Hide all base layers
    basemaps.Street.setVisible(false);
    basemaps.Satellite.setVisible(false);

    // Show selected layer
    if (mapType === "Street") {
      basemaps.Street.setVisible(true);
      setActiveBasemap("Street");
    } else {
      basemaps.Satellite.setVisible(true);
      setActiveBasemap("Satellite");
    }
    // console.log(`Switched to ${mapType}`);
  };

  // ================================================
  // STEP 13: KEEP SAME RETURN/RENDER (MINIMAL CHANGES)
  // ================================================
  return (
    <>
      <div ref={mapRef} id="viewDiv" style={{ height: mapHeight || "100vh" }} className={classList}>
        {showExtraButton && (
          <>
            <div className="site-filter">
              <Select
                className="site-filter-box"
                placeholder="Select Site"
                isClearable
                isLoading={isLoading}
                options={sites}
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setSiteFilter(selectedOption.value);
                    setGisFeatureLayerFilter({ Site: selectedOption.value });
                    // Zoom to site extent
                    // zoomToSiteExtent(selectedOption.value);
                    Http.request(
                      "post",
                      `${process.env.REACT_APP_API_URL}land-parcel/gis`,
                      {
                        filterDataSet: {
                          sites: [selectedOption.value],
                        },
                      },
                      apiHeaders(),
                    )
                      .then((result) => {
                        setLandSummary(result?.data);
                      })
                      .catch((error) => {});
                  } else {
                    setSiteFilter(``);
                    setGisFeatureLayerFilter({
                      ...gisFeatureLayerFilterData,
                      Site: "",
                    });
                    // Hide land parcels layer
                    if (landParcelsLayerRef.current) {
                      landParcelsLayerRef.current.setVisible(false);
                    }

                    // Zoom to default
                    if (mapInstance.current && view) {
                      view.animate({
                        center: fromLonLat(mapCenterPostion.center || [71.5724, 22.6708]),
                        zoom: 5,
                        duration: 500,
                      });
                    }
                    Http.request(
                      "post",
                      `${process.env.REACT_APP_API_URL}land-parcel/gis`,
                      null,
                      apiHeaders(),
                    )
                      .then((result) => {
                        setLandSummary(result?.data);
                      })
                      .catch((error) => {});
                  }
                }}
              />

              <OverlayTrigger trigger="click" placement="bottom" overlay={popoverForm} rootClose>
                <Button
                  className={
                    "btn-grad gis-button " +
                    (siteFilter || gisFeatureLayerFilterData.Site ? "" : "disabled")
                  }
                  disabled={siteFilter || gisFeatureLayerFilterData.Site ? false : true}
                  variant="secondary"
                >
                  <i className="material-icons opacity-10 pe-1">print</i>
                </Button>
              </OverlayTrigger>

              <button
                className={
                  "btn-grad gis-button " +
                  (siteFilter || gisFeatureLayerFilterData.Site ? "" : "disabled")
                }
                disabled={siteFilter || gisFeatureLayerFilterData.Site ? false : true}
                onClick={exportKML}
              >
                {!loading && <i className="material-icons opacity-10 pe-1">file_download</i>}
                {loading && (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                <span className="dashboard-icons mt-1">&nbsp;KML/KMZ</span>
              </button>
            </div>

            <div id="base-map-container" className={"base-map-container "}></div>

            <div className="measurement-area">
              <Select
                className="mesaure-box"
                placeholder="Measure"
                isClearable
                options={[
                  {
                    label: "Distance",
                    value: "distance",
                  },
                  {
                    label: "Area",
                    value: "area",
                  },
                ]}
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    toggleMeasurementType(selectedOption.value);
                    setMeasurementActive(selectedOption.value);
                  } else {
                    toggleMeasurementType(null);
                    setMeasurementActive(null);
                  }
                }}
              />
              {/* UNIT SELECTION (shown when measuring) */}
              {measurementActive === "distance" && (
                <Select
                  className="unit-selector"
                  value={{
                    label:
                      measurementUnit.distance === "meters"
                        ? "Meters"
                        : measurementUnit.distance === "kilometers"
                        ? "Kilometers"
                        : "Meters",
                    // : measurementUnit.distance === "feet"
                    // ? "Feet"
                    // : "Meters",
                    value: measurementUnit.distance,
                  }}
                  options={[
                    { label: "Meters", value: "meters" },
                    { label: "Kilometers", value: "kilometers" },
                    // { label: "Feet", value: "feet" },
                  ]}
                  onChange={(selectedOption) => {
                    setMeasurementUnit((prev) => ({
                      ...prev,
                      distance: selectedOption?.value || "meters",
                    }));
                  }}
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: "120px",
                      marginLeft: "10px",
                    }),
                  }}
                />
              )}

              {measurementActive === "area" && (
                <Select
                  className="unit-selector"
                  value={{
                    label:
                      measurementUnit.area === "squareMeters"
                        ? "Square Meters"
                        : measurementUnit.area === "squareKilometers"
                        ? "Square Kilometers"
                        : // : measurementUnit.area === "squareFeet"
                        // ? "Square Feet"
                        measurementUnit.area === "hectares"
                        ? "Hectares"
                        : "Square Meters",
                    value: measurementUnit.area,
                  }}
                  options={[
                    { label: "Square Meters", value: "squareMeters" },
                    { label: "Square Kilometers", value: "squareKilometers" },
                    // { label: "Square Feet", value: "squareFeet" },
                    { label: "Hectares", value: "hectares" },
                  ]}
                  onChange={(selectedOption) => {
                    setMeasurementUnit((prev) => ({
                      ...prev,
                      area: selectedOption?.value || "squareMeters",
                    }));
                  }}
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: "150px",
                      marginLeft: "10px",
                    }),
                  }}
                />
              )}
            </div>
            {/* 
            <div id="opacitySliderContainer" className="trans-slider">
              <button
                className="btn-grad gis-button"
                onClick={() => setTransparency(!transparency)}
              >
                <span className="gis-label">Transparency</span>
                <span title="Transparency" className="material-icons gis-icon">
                  content_paste_search
                </span>
              </button>
              {transparency && (
                <>
                  <input
                    type="range"
                    onChange={(e) => manageRangeSlider(parseFloat(e.target.value))}
                    min="0"
                    max="1"
                    step="0.01"
                    defaultValue="1"
                    id="opacitySlider"
                  />
                  <div id="sliderHandle"></div>
                </>
              )}
            </div> */}

            {/*  <button
              className="btn-grad label-button"
              onClick={() => {
                setLabel();
              }}
            >
              <span className="gis-label">Label</span>
              <span title="Label" className="material-icons gis-icon">
                label
              </span>
            </button> */}

            <div className="gis-map-type">
              <div className="dropdown" style={{ paddingRight: "10px" }}>
                <div className="nav-item dropdown align-items-center pe-2">
                  <Link
                    className="nav-link font-weight-bold d-flex text-white dropdown-toggle"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    <i className="material-icons opacity-10 pe-1">public</i>
                  </Link>
                  {/* <ul className="dropdown-menu dropdown-menu-end" style={{ minWidth: "90px" }}>
                    <li className="map-type-li">
                      <Link onClick={() => toggleBasemap("hybrid")}>
                        <span>Hybrid</span>
                      </Link>
                    </li>
                    <li className="map-type-li">
                      <Link onClick={() => toggleBasemap("streets")}>
                        <span>Streets</span>
                      </Link>
                    </li>
                    <li className="map-type-li">
                      <Link onClick={() => toggleBasemap("satellite")}>
                        <span>Satellite</span>
                      </Link>
                    </li>
                  </ul> */}
                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    style={{
                      minWidth: "90px",
                      background: "#0c0c0c85",
                    }}
                  >
                    <li className="map-type-li">
                      <button
                        onClick={() => changeBaseMap("Satellite")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          width: "100%",
                          padding: "8px 12px",
                          background:
                            activeBasemap === "Satellite"
                              ? "rgba(76, 175, 80, 0.3)"
                              : "transparent",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          color: "white",
                          fontSize: "14px",
                          transition: "all 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          if (activeBasemap !== "Satellite") {
                            e.currentTarget.style.background = "rgba(255,255,255,0.1)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (activeBasemap !== "Satellite") {
                            e.currentTarget.style.background = "transparent";
                          }
                        }}
                        title="Satellite"
                      >
                        <img
                          src="images/satellite.jpeg"
                          alt="Satellite"
                          width="35"
                          height="35"
                          style={{
                            borderRadius: "3px",
                            border:
                              activeBasemap === "Satellite"
                                ? "2px solid #4CAF50"
                                : "1px solid rgba(255,255,255,0.3)",
                          }}
                        />
                        <span>Satellite</span>
                        {activeBasemap === "Satellite" && (
                          <i
                            className="material-icons"
                            style={{
                              marginLeft: "auto",
                              fontSize: "18px",
                              color: "#4CAF50",
                            }}
                          >
                            check_circle
                          </i>
                        )}
                      </button>
                    </li>

                    <li className="map-type-li" style={{ marginTop: "5px" }}>
                      <button
                        onClick={() => changeBaseMap("Street")}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          width: "100%",
                          padding: "8px 12px",
                          background:
                            activeBasemap === "Street" ? "rgba(76, 175, 80, 0.3)" : "transparent",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          color: "white",
                          fontSize: "14px",
                          transition: "all 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          if (activeBasemap !== "Street") {
                            e.currentTarget.style.background = "rgba(255,255,255,0.1)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (activeBasemap !== "Street") {
                            e.currentTarget.style.background = "transparent";
                          }
                        }}
                        title="Street"
                      >
                        <img
                          src="images/google-street.jpeg"
                          alt="Street"
                          width="35"
                          height="35"
                          style={{
                            borderRadius: "3px",
                            border:
                              activeBasemap === "Street"
                                ? "2px solid #4CAF50"
                                : "1px solid rgba(255,255,255,0.3)",
                          }}
                        />
                        <span>Street</span>
                        {activeBasemap === "Street" && (
                          <i
                            className="material-icons"
                            style={{
                              marginLeft: "auto",
                              fontSize: "18px",
                              color: "#4CAF50",
                            }}
                          >
                            check_circle
                          </i>
                        )}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
